import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Tooltip,
  IconButton,
  Modal,
  Box,
  Autocomplete,
  Grid,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import AutorenewIcon from "@mui/icons-material/Autorenew";

function DataGridUserManagement({
  isLoading,
  rows,
  handleEditClick,
  handleOpenStatusModal,
  sortTableCell,
  itemsPerPageList,
  itemsPerPage,
  currentPage,
  handlePageChange,
  handleChangeItemPerPageSelect,
  totalItems,
  tableCellStyle,
  dataProfile,
}) {
  const canEditRow = (row) => {
    const userRole = dataProfile?.role_code;

    if (!userRole) return false;

    if (userRole === "SA") {
      return row.role_code !== "SA";
    } else if (userRole === "A") {
      return row.role_code !== "SA" && row.role_code !== "A";
    } else if (userRole === "COA") {
      return (
        row.role_code !== "SA" &&
        row.role_code !== "A" &&
        row.role_code !== "COA"
      );
    } else {
      return false;
    }
  };

  return (
    <Paper sx={{ width: "auto", overflow: "hidden", padding: "0rem 1rem" }}>
      <TableContainer sx={{ maxHeight: 650 }}>
        <Table
          aria-label="simple table"
          sx={{
            border: 1,
            borderColor: "grey.300",
            borderCollapse: "collapse",
          }}
        >
          <TableHead>
            <TableRow>
              {sortTableCell("User Name", "user_name")}
              {sortTableCell("Full Name", "full_name")}
              {sortTableCell("Role Name", "role_name")}
              {sortTableCell("Status", "status")}
              <TableCell
                style={tableCellStyle}
                sx={{ border: 1, borderColor: "grey.300" }}
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length > 0 ? (
              rows.map((row) => (
                <TableRow key={row.id}>
                  <TableCell
                    align="center"
                    sx={{
                      border: 1,
                      borderColor: "grey.300",
                      padding: "8px 0px",
                    }}
                  >
                    {row.user_name}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      border: 1,
                      borderColor: "grey.300",
                      padding: "8px 0px",
                    }}
                  >
                    {row.full_name}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      border: 1,
                      borderColor: "grey.300",
                      padding: "8px 0px",
                    }}
                  >
                    {row.role_name}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      border: 1,
                      borderColor: "grey.300",
                      padding: "8px 0px",
                    }}
                  >
                    {row.status === "1" ? (
                      <span
                        style={{
                          background: "#5fc254ff",
                          color: "white",
                          padding: "4px 10px",
                          borderRadius: "4px",
                        }}
                      >
                        Active
                      </span>
                    ) : (
                      <span
                        style={{
                          background: "#dd4848ff",
                          color: "white",
                          padding: "4px 10px",
                          borderRadius: "4px",
                        }}
                      >
                        Inactive
                      </span>
                    )}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ border: 1, borderColor: "grey.300", padding: "8px 0px" }}
                  >
                    {canEditRow(row) && (
                      <>
                        <Tooltip
                          sx={{ padding: "0px 10px" }}
                          title="Edit User"
                          onClick={() => {
                            handleEditClick(row);
                          }}
                        >
                          <IconButton>
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                        {row.role_code === "13" || row.role_code === "14" ? (
                          <Tooltip
                            sx={{ padding: "0px 10px" }}
                            title="Edit User Status"
                            onClick={() => handleOpenStatusModal(row)}
                          >
                            <IconButton>
                              <AutorenewIcon />
                            </IconButton>
                          </Tooltip>
                        ) : null}
                      </>
                    )}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={10}
                  align="center"
                  sx={{ border: 1, borderColor: "grey.300" }}
                >
                  {isLoading ? "Loading..." : "No Data Available"}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {/* pagination */}
      {rows.length > 0 && (
        <TablePagination
          rowsPerPageOptions={itemsPerPageList}
          component="div"
          count={totalItems}
          rowsPerPage={itemsPerPage}
          page={currentPage - 1}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleChangeItemPerPageSelect}
        />
      )}
    </Paper>
  );
}

export default DataGridUserManagement;
